import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Configuration } from '../../app.constants';


export class Documents {
  // StudentDocumentID : number;
  // StudentID : number;
  DocumentID : number;
  DocumentName : string;
  // checkedValue : string;
  // chk:boolean;
  // DocumentApprovedFlag : string;
  // DocumentRemark : string;
  // DocumentApprovedByID : number;
  // DocumentApprovedDate  : string;
  // DeleteFlag  : string;
  // CreatedLoginID : number;
  // UpdatedLoginID : number;
  // DocumentPath:string;
  // CompOptFlag:string;
}

export class AcademicInstanceSchedule{
  PRNNo: number;
  StudentName: string;
  Gender:string;
  PhyDisability:string;
  ReDegree:string;
  ApplyForImprovement:string;
  CourseName:string;
  CoursePatternName:string;
  BranchName:string;
  CoursePartName:string;
  CollegeName:string;
  RequestID: number;
  RequestDate:string;
  TotalFeeAmount: number;
  Activity: string;
 // SubjectData:Subjectlist[];
}


export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};

export class GetCourse {
  CourseID :number;
  CourseName: string;
  CourseShortName: string;
};
export class columnSetting {
  RequestID: number;
  PRNNo: number;
  StudentName: string;
  TotalFeeAmount: number;
  ImprovementFlag: string;
  ApprovalFlag: string;
  ApprovalDate: string;
  ApprovalRemark: string;
};

/* export class Subjectlist {
  SubjectId: number;
  SubName: string;
}; */
export class Formdatacolumns {
  AcademicInstance: string;
  StartDate: string;
  EndDate: string;
  EndDaApplicableToAllBrancheste: false;
  StudentType: string;
};
let Formdata: Formdatacolumns[] = [{
  AcademicInstance: "2018-2019",
  StartDate: "28-Feb-2019",
  EndDate: "28-Feb-2019",
  EndDaApplicableToAllBrancheste: false,
  StudentType:"Regular"
}]
let columnSettings: columnSetting[] = [{
  RequestID: 1,
  PRNNo: 123456789,
  StudentName: "ashwini",
  TotalFeeAmount:1000,
  ImprovementFlag: "Y",
  ApprovalFlag: "Y",
  ApprovalDate: "04/Feb/2019",
  ApprovalRemark: "approval Successfully"
},
{
  RequestID: 2,
  PRNNo: 123456789,
  StudentName: "xyz",
  TotalFeeAmount:2000,
  ImprovementFlag: "N",
  ApprovalFlag: "N",
  ApprovalDate: "04/Feb/2019",
  ApprovalRemark: "Not Approval"
},
];
/* let FeesData : Subjectlist[] = [{
  SubjectId: 1,
  SubName: "Physics"
},
{
  SubjectId: 2,
  SubName: "Chemistry"
}
]; */
let getCourseData: GetCourse[] = [{
  CourseID :1,
  CourseName: "Master Of Commerce",
  CourseShortName:  "Commerce"
},
{
  CourseID :2,
  CourseName: "Bachelor Of Arts",
  CourseShortName:  "Arts"
}
];
let courselist: string[] = [
  "Master Of Commerce",
  "Commerce "
];


let gridColumnsFees: GridColumns[] = [{
  "caption": 'Fees Name',
  "dataField": "FeesID",
  "width": 300,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
},
{
  "caption": 'Amount',
  "dataField": "FeesAmount",
  "width": 200,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
},
{
  "caption": 'Rep Fees Amount',
  "dataField": "RepFeesAmount",
  "width": 200,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": false
}]
let gridColumns: GridColumns[] = [
{
  "caption": 'Request ID',
  "dataField": "RequestID",
  "width": 100,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'PRN No.',
  "dataField": "PRNNo",
  "width": 100,
  "dataType": "number",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Student Name',
  "dataField": "StudentName",
  "width": 200,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Request Date',
  "dataField": "ApprovalDate",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval',
  "dataField": "ApprovalFlag",
  "width": 100,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval Date',
  "dataField": "ApprovalDate",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Approval Remark',
  "dataField": "ApprovalRemark",
  "width": 150,
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}
];
export class Collegeproduct {
  CourseId: number;
  CourseName: string;
}
let Collegeproducts: Collegeproduct[] = [{
  "CourseId": 1,
  "CourseName": "ABC College"
}, {
  "CourseId": 2,
  "CourseName": "XYZ College"
}]
export class GenderProduct {
  GenderFlag: string;
  GenerName: String;
}
/* let Genderproducts: GenderProduct[] = [{
  "GenderFlag": "M",
  "GenerName": "Male"
}, {
  "GenderFlag":"F",
  "GenerName": "Female"
},
{
  "GenderFlag":"O",
  "GenerName": "Other"
}] */
let Genderproducts: string[] = [
  "Male",
  "Female",
];

let ReDegreeproducts: string[] = [
  "Yes",
  "No",
];
let ApplyForImprovementproducts: string[] = [
  "Yes",
  "No",
];
let CourseproductsNew: string[] = [
  "Physics",
  "Applied Chemistry",
];
let CoursePatternProducts: string[] = [
  "Semister I",
  "Semister II",
];
let Branchproducts: string[] = [
  "Arts",
  "General",
];

export class FeesProduct {
  FeesId: number;
  FeesName: string;
}

let Feesproducts: FeesProduct[] = [{
  "FeesId": 1,
  "FeesName": "Exam Fee"
}, {
  "FeesId": 2,
  "FeesName": "Tution Fee"
},
{
  "FeesId": 3,
  "FeesName": "Convocation Fee"
},
{
  "FeesId": 4,
  "FeesName": "Other Fee"
}]

export class StudTypeProduct {
  StudTypeId: number;
  StudTypeName: string;
}
let StudTypeproducts: StudTypeProduct[] = [{
  "StudTypeId": 1,
  "StudTypeName": "Physics"
}, {
  "StudTypeId": 2,
  "StudTypeName": "Applied Chemistry"
}];

let studentData = {
  PRNNo: '20171031007',
  Prefix: 1,
  FirstName: "Saurabh",
  MiddleName: "Deepak",
  LastName: "Rabade",
  Gender:"Male",
  PhyDisability:"No",
  ReDegree:"No",
  ApplyForImprovement:"No",
  CourseName:"Bachelor of Arts",
  CoursePatternName:"Semester",
  BranchName:"Arts",
  CoursePartName:"No",
  CollegeName:"New College, Kolhapur",
  RequestID: 1,
  RequestDate: '',
  TotalFeeAmount: 1000,
  Activity: "Y"
};
let getNewInstance: AcademicInstanceSchedule={
  PRNNo: 12345613,
  StudentName: "ashwini",
  Gender:"Male",
  PhyDisability:"No",
  ReDegree:"No",
  ApplyForImprovement:"No",
  CourseName:"Commerce",
  CoursePatternName:"Semister I",
  BranchName:"Arts",
  CoursePartName:"No",
  CollegeName:"New College Kolhapur",
  RequestID: 1,
  RequestDate:"05/Feb/2019",
  TotalFeeAmount: 1000,
  Activity: "Y"/* ,
  SubjectData:[{
      SubjectId: 1,
      SubName: "Physics"
    },
    {
      SubjectId: 2,
      SubName: "Chemistry"
    }] */
}
export class Company {
  ID: number;
  CompanyName: string;
  PRNNo:string;
  Address: string;
  City: string;
  State: string;
  Zipcode: number;
  Phone: string;
  Fax: string;
  Website: string;
  Template:string;
}
export class NameChange{
  StudentNameChangeRequestID: number;
  StudentID: number;
  FormNo: string;
  RequestDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  BranchID: number;
  CollegeID: number;
  TransferCollegeID: number;
  ApplicationFees: number;
  ApplicationFeesReceivedDate: string;
  ApplicationDDNO: string;
  ApplicationBankName: string;
  ApplicationBankDDDate: string;
  CollegeChangeRemark:string;
  PaymentMode:string;
  ApplicationStatus: string;
  ApplicationDDConfirm: string;
  ApprovedFlag: string;
  ApprovalDate:string;
  ApprovalRemark: string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  DocumentPath:string;
  ApplicationNO:string;
  
}
let companies: Company[] = [{
  "ID": 1,
  "CompanyName": "Personal Details",
  "PRNNo":"12345631331",
  "Address": "702 SW 8th Street",
  "City": "Bentonville",
  "State": "Arkansas",
  "Zipcode": 72716,
  "Phone": "(800) 555-2797",
  "Fax": "(800) 555-2171",
  "Website": "http://www.nowebsitesupermart.com",
  "Template": "<div class='dx-field-label'>Default mode</div> <div class='dx-field-value'> <dx-text-box value='John Smith'></dx-text-box></div>",
},
{
  "ID": 2,
  "CompanyName": "Course Details",
  "PRNNo":"",
  "Address": "2455 Paces Ferry Road NW",
  "City": "Atlanta",
  "State": "Georgia",
  "Zipcode": 30339,
  "Phone": "(800) 595-3232",
  "Fax": "(800) 595-3231",
  "Website": "http://www.nowebsitedepot.com",
  "Template": "",
}, {
  "ID": 3,
  "CompanyName": "Request Details",
  "PRNNo":"",
  "Address": "1000 Nicllet Mall",
  "City": "Minneapolis",
  "State": "Minnesota",
  "Zipcode": 55403,
  "Phone": "(612) 304-6073",
  "Fax": "(612) 304-6074",
  "Website": "http://www.nowebsitemusic.com",
  "Template": "",
}];

@Injectable({
  providedIn: 'root'
})
export class NamechangeService {
  getCompanies(): Company[] {
    return companies;
  }
  selectedAcademicInstance :AcademicInstanceSchedule;
  constructor(
    private dataService: DataAccessService,private http : HttpClient,private Configuration:Configuration) {
  }
  public GetCollegeChangeData(StudentID) {debugger
    this.dataService.setControllerName = '/PortalBranchChange/';
    this.dataService.setMethodName = 'GetDataForPortalBranchChangeByStudentID?StudentID='+ StudentID; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public GetSequenceNO(Formnm) {debugger
    this.dataService.setControllerName = '/PortalBranchChange/';
    this.dataService.setMethodName = 'GetSequenceNO?Formnm='+ Formnm; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public CheckNameRequestStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'CheckNameRequestStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public GetChangedNameData(StudentID,CoursePartID,BranchID,CollegeID) {debugger
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'GetChangedNameData?StudentID='+ StudentID +'&CoursePartID='+CoursePartID + '&BranchID='+ BranchID + '&CollegeID=' + CollegeID + ''; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'PostInsertPortalStudentNameChangeNEW'; // setting method name from API controller.
    return this.dataService.add<NameChange[]>(data) 
  }
  public CancelNameChangeApplication(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'CancelNameChangeApplication?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
    return this.dataService.getAll<NameChange[]>()
  }
  public GetDataforNameChangeList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'GetDataforNameChangeList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public GetUpdatePaymentStatusForNameChange(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForNameChange?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  public GetDocumentPathForNameChange(StudentNameChangeRequestID) {debugger
    this.dataService.setControllerName = '/PortalStudentNameChange/';
    this.dataService.setMethodName = 'GetDocumentPathForNameChange?StudentNameChangeRequestID='+ StudentNameChangeRequestID
    return this.dataService.getAll<NameChange[]>()
  }

  public GetNameChangeReport(StudentID,ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/FormPrintReportCertficatesRequest/';
    this.dataService.setMethodName = 'GetNameChangeReport?StudentID='+StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<NameChange[]>()
  }
  getNewAcademicInstance(){
    return  getNewInstance;
  }

  setSelectedAcademicInstance(dataInstance:AcademicInstanceSchedule){
    this.selectedAcademicInstance=dataInstance;
  }
  getSelectedAcademicInstance(){
    return  this.selectedAcademicInstance ={
      PRNNo: 12345613,
      StudentName: "ashwini",
      Gender:"Male",
      PhyDisability:"No",
      ReDegree:"No",
      ApplyForImprovement:"No",
      CourseName:"Commerce",
      CoursePatternName:"Semister I",
      BranchName:"Arts",
      CoursePartName:"No",
      CollegeName:"New College Kolhapur",
      RequestID: 1,
      RequestDate:"05/Feb/2019",
      TotalFeeAmount: 1000,
      Activity: "Y"/* ,
      SubjectData:[{
          SubjectId: 1,
          SubName: "Physics"
        },
        {
          SubjectId: 2,
          SubName: "Chemistry"
        }] */
    };
  }
  getGridColumnsData() {
    return columnSettings[0];
  }
  getGridColumns() {
    return gridColumns;
  }
  getGridColumnsFees(){
    return gridColumnsFees;
  }
  getCourse() {
    return getCourseData;
  }
  getData() {
    return columnSettings;
  }
 /*  getDataForFees(){
    return FeesData;
  } */
  getcourselist(){
    return courselist;
  }
  getCourseProducts() {
    return Collegeproducts;
  }
  getFeesProducts() {
    return Feesproducts;
  }

  getDataForm() {
    return Formdata;
  }
  getStudTypeProducts(){
    return StudTypeproducts;
  }
  getGenderProducts() {
    return Genderproducts;
  }

  getReDegreeProducts() {
    return ReDegreeproducts;
  }
  getApplyForImprovementProducts() {
    return ApplyForImprovementproducts;
  }
  getCourseProductsNew() {
    return CourseproductsNew;
  }
  getCoursePatternProducts() {
    return CoursePatternProducts;
  }
  getBranchProducts() {
    return Branchproducts;
  }

  getStudentData() {
    return studentData;
  }

  public GetDocumentsForNameChange() {debugger
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'GetDocumentsForNameChange?DocumentID=0';   // setting method name from API controller.
    debugger
    return this.dataService.getAll<Documents[]>()
  }

  public getDocumentByDocumentID(DocumentID) {debugger
    this.dataService.setControllerName = '/PreStudentDocuments/';
    this.dataService.setMethodName = 'GetDocumentsForNameChange?DocumentID='+DocumentID;  // setting method name from API controller.
    return this.dataService.getAll<Documents[]>()
  }


  //FOR FILE UPLOAD


uploadNameChangePdf(file: File,data:any) {
  debugger
  var queryParam="?RequestID=" + data.RequestID + "&ExamInstanceID="+ data.ExamInstanceID +"&DocumentName="+data.DocumentName+'';
  const endpoint = this.Configuration.serverWithApiUrl +"/PreStudentDocuments/UploadStudentNameChange"+queryParam; 
  const formData: FormData = new FormData();
  formData.append( 'file', file,file.name);
  return this.http
    .post(endpoint, formData);
}

public deleteUploadedPdfDocument(data:any){debugger;
  this.dataService.setControllerName = '/PortalStudentNameChange/';
  this.dataService.setMethodName = 'PostDeletePortalStudentNameChangeDocument' ; // setting method name from API controller
  return this.dataService.delete<NameChange>(data);
}


public GetApllicationNoByRequestID(RequestID) {debugger
  this.dataService.setControllerName = '/PortalStudentNameChange/';
  this.dataService.setMethodName = 'GetApllicationNoByRequestID?RequestID='+RequestID;  // setting method name from API controller.
  return this.dataService.getAll<NameChange[]>()

}


}
